import React from "react";
import { NavLink, Outlet, Link } from "react-router-dom";
import { LayoutDashboard, Package, ShoppingBag, Repeat, Users, Settings, LogOut, AlertTriangle , Camera} from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/admin", label: "Dashboard", end: true, icon: LayoutDashboard },
  { to: "/admin/attention", label: "Attention Queue", icon: AlertTriangle },
  { to: "/admin/inventory", label: "Inventory", icon: Package },
  { to: "/admin/orders", label: "Orders", icon: ShoppingBag },
  { to: "/admin/sell-to-lookers", label: "Sell to Lookers", icon: Repeat },
  { to: "/admin/customers", label: "Customers", icon: Users },
  { to: "/admin/reviews", label: "Photos & Reviews", icon: Camera },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen flex bg-[#FAFAF9]" data-testid="admin-layout">
      <aside className="w-64 bg-white border-r border-zinc-200 shrink-0 flex flex-col">
        <div className="p-6 pt-8 border-b border-zinc-100">
          <Link to="/"><img src={`${process.env.REACT_APP_BACKEND_URL}/api/files/lookers/branding/logo_black.png`} alt="Lookers" width="700" height="143" className="h-9 w-auto" /></Link>
          <div className="text-[10px] font-heading uppercase tracking-wide text-zinc-400 mt-2">Admin</div>
        </div>
        <nav className="flex-1 py-4 px-3 space-y-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-full text-sm font-heading font-semibold uppercase tracking-wide transition-colors ${
                  isActive ? "bg-teal-600 text-ink" : "text-zinc-500 hover:bg-teal-50 hover:text-teal-800"
                }`
              }
              data-testid={`admin-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <n.icon size={16} />
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 m-3 rounded-xl bg-zinc-50 border border-zinc-100 text-xs text-zinc-500">
          <div className="font-heading font-semibold text-zinc-800 mb-2 truncate">{user?.name}</div>
          <button onClick={logout} className="flex items-center gap-1.5 text-teal-700 hover:text-teal-800 font-heading font-semibold uppercase tracking-wide text-[11px]" data-testid="admin-logout-button">
            <LogOut size={13} /> Log out
          </button>
        </div>
      </aside>
      <div className="flex-1 overflow-x-hidden">
        <Outlet />
      </div>
    </div>
  );
}
